import React from "react";
import { Body2, Body3, CheckedCheckBox, Label1, UncheckedCheckBox, media, styled } from "@iventis/styles";
import { Theme } from "@emotion/react";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";

import { Content } from "@iventis/translations";
import { Checkbox, Link, useTheme } from "@mui/material";
import { IVENTIS_TERMS_URL } from "@iventis/utilities";

export const tickboxStyle = {
    marginRight: "13px",
    height: "20px",
    alignSelf: "top",
    minHeight: "15px",
    padding: "0px",
};

export const TermsAndConditionsCheckbox: React.FC<{ onChange?; onBlur?; className?: string; errors?; touched?; forgottenPasswordCheckbox?: boolean }> = ({
    onChange,
    onBlur,
    className,
    errors,
    touched,
    forgottenPasswordCheckbox,
}) => {
    const translate = useIventisTranslate();
    const theme = useTheme<Theme>();
    return (
        <StyledTacContainer>
            <StyledTaCInputContainer className={className}>
                <Checkbox
                    icon={
                        <UncheckedCheckBox
                            size={15}
                            borderStyle={forgottenPasswordCheckbox ? "1px solid rgba(0,0,0,0.23)" : "0px"}
                            backgroundColour={theme.secondaryColors.blank}
                        />
                    }
                    checkedIcon={
                        <CheckedCheckBox
                            size={15}
                            tickColour="white"
                            borderStyle={forgottenPasswordCheckbox ? "1px solid transparent" : "0px"}
                            backgroundColour={theme.primaryColors.focus}
                        />
                    }
                    onChange={onChange}
                    name="termsAndConditions"
                    aria-labelledby="termsAndConditions"
                    aria-label="consent-terms-and-conditions"
                    onBlur={onBlur}
                    size="small"
                    style={{ ...tickboxStyle, minWidth: forgottenPasswordCheckbox ? "17px" : "15px" }}
                    data-testid="terms-and-conditions-agree"
                />
                <Label1 style={{ display: "inline-block", textAlign: "left" }} htmlFor="termsAndConditions">
                    <Body2>
                        {translate(Content.login.options.consentTos1)}&nbsp;
                        <Link className={`${className}-link`} target="_blank" rel="noreferrer" href={IVENTIS_TERMS_URL}>
                            {translate(Content.login.links.termsAndCo)}
                        </Link>{" "}
                        {translate(Content.login.options.consentTos2)}
                    </Body2>
                </Label1>
            </StyledTaCInputContainer>
            <StyledErrorBox>
                <StyledErrorMessage>
                    <Body3>{errors.termsAndConditions && touched.termsAndConditions && errors.termsAndConditions}</Body3>
                </StyledErrorMessage>
            </StyledErrorBox>
        </StyledTacContainer>
    );
};

const StyledTacContainer = styled.div`
    display: flex;
    flex-direction: column;
    // Content + error text, so no jumping
    min-height: 50px;
    ${media.extraSmall} {
        min-height: 70px;
    }
`;

const StyledTaCInputContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: top;
    margin-top: 29px;
    align-content: top;
    margin-bottom: 4px;
`;

const StyledErrorMessage = styled.span`
    display: block;
    color: ${({ theme }: { theme: Theme }) => theme.toastColours.error};
    margin-left: 33px;
    text-align: left;
`;

const StyledErrorBox = styled.div`
    display: block;
`;
